import { Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { CategoryLinkModalData, ShowCategoryLinkModalActions } from './show.category.link.modal.provider';
import { AlertifyService } from '../../../services/alertify.service';

@Component({  
  templateUrl: './show.category.link.modal.component.html',
  styleUrls: ['./show.category.link.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowCategoryLinkModalComponent extends BaseComponent {
  public link: string;
  public jsonApi: string;
  
  constructor(
    private dialogRef: MatDialogRef<ShowCategoryLinkModalComponent>,
    private actions: ShowCategoryLinkModalActions,
    private alertify: AlertifyService,
    data: CategoryLinkModalData
  ) {
    super();
    this.link = data.link;
    this.jsonApi = data.jsonApi;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public copyLink() {
    this.copyToClip(this.link);
  }

  public copyJsonApi() {
    this.copyToClip(this.jsonApi);
  }

  private copyToClip(content) {
    let aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    this.alertify.success('Link is copied to the clipboard');
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.category.link.modal/show.category.link.modal.component.ts